export const UNDER_5 = "UNDER_5";
export const OVER_70 = "OVER_70";
export const EXEMPTION_TYPE = "exemptionType";
